import React from 'react';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';
import { GiftOrderSummaryItemSize } from 'features/dashboard/components/GiftOrderSummaryItem';
import { BulkEmailVerificationType } from 'features/dashboard/ts/OrderSummary';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'hooks/useTranslation';

type UndeliverableEmailsBlockType = {
  size: GiftOrderSummaryItemSize;
  undeliverableEmails: Array<BulkEmailVerificationType>;
};

const UndeliverableEmailsBlock: React.FC<UndeliverableEmailsBlockType> = ({ size, undeliverableEmails }) => {
  const { t } = useTranslation('dashboard');
  const classes = useStyles({ size });
  return (
    <Box display="flex" flexDirection="column" className={classes.container}>
      <Typography className={classes.header}>{t('undeliverableEmails')}</Typography>
      {undeliverableEmails.map(({ address, message }) => (
        <Box display="flex" justifyContent="space-between" key={address} className={classes.row}>
          <Typography>{address}</Typography>
          <Typography>{message}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default UndeliverableEmailsBlock;
